/* ---- Hold the cookie banner back for a few seconds -----------------------

   The banner itself is Shopify's, wired to the Customer Privacy API. There
   is no hook to delay its injection, so the delay is presentational: the
   theme hides it, then reveals it.

   WHY THIS IS JS AND NOT A CSS ANIMATION DELAY.

   The obvious version is `opacity:0; animation: ... 5s forwards`. It works,
   right up until the animation does not complete -- and then the banner is
   invisible and unclickable forever. For a decorative element that is a
   cosmetic bug. For the control that gates consent it means a visitor can
   neither accept nor decline, which is worse than showing the banner
   instantly.

   So this fails VISIBLE, in three layers:

     1. The hiding rule is scoped to html.trulvl-consent-delay, and that
        class is added by THIS script. No JS -> no class -> the banner
        renders immediately, exactly as Shopify intended.
     2. The reveal is a class flip plus a CSS transition, not an animation
        timeline. A backgrounded tab throttles rAF and can stall an
        animation mid-flight; a class that is already applied simply
        renders when the tab is next painted.
     3. A hard failsafe reveals it at 12s no matter what, so a slow
        injection or an error above cannot strand it.

   The banner is injected asynchronously, so we cannot just query for it on
   load -- hence the observer, with the timer starting from first paint
   rather than from whenever Shopify happens to inject.
-------------------------------------------------------------------------- */
(function () {
  "use strict";

  var DELAY_MS = 5000;
  var FAILSAFE_MS = 12000;
  var HIDE_CLASS = "trulvl-consent-delay";
  var SHOW_CLASS = "trulvl-consent-shown";
  var root = document.documentElement;
  var start = Date.now();
  var revealed = false;

  root.classList.add(HIDE_CLASS);

  function reveal() {
    if (revealed) return;
    revealed = true;
    var el = document.getElementById("shopify-pc__banner");
    if (el) el.classList.add(SHOW_CLASS);
    // Drop the global hook too, so nothing stays hidden if the banner is
    // re-injected later (Shopify does this on some navigations).
    root.classList.remove(HIDE_CLASS);
    if (observer) observer.disconnect();
  }

  function scheduleFrom(el) {
    try { bindPhrase(el); } catch (e) { /* cosmetic only -- never block the reveal */ }
    var elapsed = Date.now() - start;
    var wait = Math.max(0, DELAY_MS - elapsed);
    setTimeout(reveal, wait);
  }

  var existing = document.getElementById("shopify-pc__banner");
  var observer = null;
  if (existing) {
    scheduleFrom(existing);
  } else {
    observer = new MutationObserver(function () {
      var el = document.getElementById("shopify-pc__banner");
      if (el) { observer.disconnect(); observer = null; scheduleFrom(el); }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---- Keep "for these purposes" together ------------------------------

     The owner wants "for" to start the third line rather than dangle at
     the end of the second. Tuning the card width to land the break there
     would work today and break the moment Shopify edits a word of this
     copy -- and Shopify owns it.

     Binding the phrase instead is content-relative rather than
     width-relative: if "for these purposes" cannot fit on line two, the
     whole phrase moves down together, which puts "for" at the start of
     line three at any width. It is the orphan rule from CLAUDE.md applied
     to a string we cannot edit.

     Desktop only -- on a phone the card is narrow and every line is
     tight, so forcing a three-word phrase to stay together risks a worse
     break than the one it fixes. */
  function bindPhrase(el) {
    if (!window.matchMedia || !window.matchMedia("(min-width: 768px)").matches) return;
    var PHRASE = "for these purposes";
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var i = node.data.indexOf(PHRASE);
      if (i === -1) continue;
      var after = node.splitText(i);
      after.splitText(PHRASE.length);
      var span = document.createElement("span");
      span.style.whiteSpace = "nowrap";
      after.parentNode.insertBefore(span, after);
      span.appendChild(after);
      return; // first occurrence only
    }
  }

  // Layer 3: nothing above can leave it hidden past this point.
  setTimeout(reveal, FAILSAFE_MS);
})();
